<template>
  <div class="cooperation-page__files-section">
    <Tabs
      :tab="activeTab"
      :received="files.received.filter((f) => f.step === step).length"
      :badge-background="isEmployer ? '#3185ce' : '#13b754'"
      @change="activeTab = $event"
    />

    <div class="cooperation-page__files-wrapper">
      <Header
        :date="stageExpire"
        :borderColor="activeTab === 0 && !isEmployer ? '#1acb61' : '#3185ce'"
        :title="activeTab === 0 ? todo : $tCooperation('Download received files')"
      />

      <SentSection
        v-if="activeTab === 0"
        :step="step"
        :files="files.sent"
        :readonly="readonly"
        :isEmployer="isEmployer"
        :isLoading="isLoading"
        @ready="$emit('ready')"
        @add="$emit('add', $event)"
        @remove="$emit('remove', $event)"
        @toggleTicketVisibility="$emit('toggleTicketVisibility', $event)"
      />

      <ReceivedSection
        v-else
        :steps="steps"
        :status="status"
        :files="files.received"
        :isEmployer="isEmployer"
        :isLoading="isLoading"
        @ready="$emit('ready')"
        @decline="$emit('decline')"
      />
    </div>
  </div>
</template>

<script>
  import Tabs from './Tabs';
  import Header from './Header';
  import SentSection from './SentSection';
  import ReceivedSection from './ReceivedSection';

  export default {
    components: { Tabs, Header, SentSection, ReceivedSection },
    props: [ 'readonly', 'files', 'todo', 'step', 'steps', 'status', 'stageExpire', 'isEmployer', 'isLoading' ],

    data() {
      return {
        activeTab: 0
      };
    }
  };
</script>
